import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_CONFIRMATION } from '../../../constants/qa'
import { LOCAL_STORAGE_REQUEST_CLOSE_CONFIRMATION_DISABLED_KEY } from '../../../constants/storage'
import { setStorageItem } from '../../../utils/storage'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { ConfirmationModal } from '../../Confirmation'

import * as styles from './RequestCloseConfirmationModal.module.css'

function RequestCloseConfirmationModal({ onCancel, onSubmit }) {
  const { t } = useTranslation()

  const [isShowAgainDisabled, setShowAgainDisabled] = useState(false)

  function handleSubmit() {
    if (isShowAgainDisabled) {
      setStorageItem(
        LOCAL_STORAGE_REQUEST_CLOSE_CONFIRMATION_DISABLED_KEY,
        isShowAgainDisabled
      )
    }

    return onSubmit()
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('Modal.YesBtnKey'),
      }}
      description={t('Request.CloseRequestConfirmationTextKey')}
      qaName={QA_NAME_CONFIRMATION}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    >
      <Checkbox
        checked={isShowAgainDisabled}
        className={styles.checkbox}
        label={t('Request.CloseRequestConfirmationCheckboxLabelKey')}
        labelClassName={styles.checkboxLabel}
        labelTitleClassName={styles.checkboxLabelTitle}
        size={CHECKBOX_SIZE.small}
        onChange={setShowAgainDisabled}
      />
    </ConfirmationModal>
  )
}

export default RequestCloseConfirmationModal
